<!--赶工下的狗屎逻辑-->
<template lang="html">
  <div>
    <div class="vip-choice-bar" :class="{IOSButton: isIosApp}" v-if="isIosApp || isHuaWei || isFilterMonthVip" @click.stop >
      <div class="vip-choice-bar-box">
        <div class="vip-choice-bar-info"  v-for="(item, index) in cardList" v-if="index === selectType">
          <div class="vip-choice-bar-countTime" v-if="!isIosApp && index && item.discountPrice < item.price && showDiscountTime > 0">
            <img src="../../assets/images/privilege-icon.png" alt="">
            <p>升级倒计时{{showDiscountTime | discountTime}}</p>
          </div>
          <span>￥</span>{{finalPayPrice}}
          <span v-if="!isFilterMonthVip">{{item | bottomDesc(isApp, isWpsAndroid)}}</span>
          <del v-else>原价698元</del>
        </div>
        <!--<div class="vip-choice-bar-info" v-if="!selectType">-->
        <!--<span>￥</span>{{finalPayPrice}}-->
        <!--<span>{{cardList[0] | bottomDesc}}</span>-->
        <!--</div>-->
        <!--<div class="vip-choice-bar-info" v-if="selectType">-->
        <!--<span>￥</span>{{finalPayPrice}}-->
        <!--<span>{{cardList[1] | bottomDesc}}</span>-->
        <!--</div>-->
        <div @click="buy" class="vip-choice-bar-button">{{isBuy? '立即续费' : '立即开通'}}</div>
      </div>
    </div>
    <div class="vip-choice" v-else>
      <div class="vip-choice" @click="$emit('closeCardChoice')">
        <div class="vip-choice-main" :class="{IOSMain: isIosApp}" @click.stop>
          <template v-if="isIosApp">
            <ul class="vip-choice-list">
              <li v-for="(item, index) in cardList" :key="index" :class="{'chooseActice': selectType===index}" @click="chooseType(index, item)">
                <div
                  class="vip-choice-list-icon ios-icon"
                  v-if="!index && (item.firstPrice < item.price) && (isWx || isApp || isWpsAndroid)">
                  新用户首月{{item.firstPrice}}元
                </div>
                <!--<img-->
                 <!---->
                  <!--src="./images/icon.png"-->
                  <!--class="vip-choice-list-icon" alt="">-->
                <p class="vip-choice-list-head">{{item.title}}</p>
                <p class="vip-choice-list-price">
                  <span>￥</span>{{item.price}}
                  <!--<span-->
                    <!--class="vip-choice-list-price-dis"-->
                    <!--v-if="!index && item.firstPrice < item.price && (isWx || isApp || isWpsAndroid)">-->
                <!--{{item.price}}-->
                  <!--</span>-->
                </p>
                <!--<p class="vip-choice-list-average">-->
                  <!--低至{{item | averagePrice(isApp, isWpsAndroid)}}/天-->
                <!--</p>-->
              </li>
            </ul>
          </template>
          <template v-else>
            <ul class="vip-choice-list">
              <li v-for="(item, index) in cardList" :key="index" :class="{'chooseActice': selectType===index}" @click="chooseType(index, item)">
                <!--<img-->
                  <!--v-if="!index && (item.firstPrice < item.price) && (isWx || isApp || isWpsAndroid)"-->
                  <!--src="./images/icon.png"-->
                  <!--class="vip-choice-list-icon" alt="">-->
                <p class="vip-choice-list-head">{{item.title}}</p>
                <p class="vip-choice-list-price">
                  <span>￥</span>{{item | cardPrice(isApp, isWpsAndroid)}}
                  <!--<span-->
                    <!--class="vip-choice-list-price-dis"-->
                    <!--v-if="!index && item.firstPrice < item.price && (isWx || isApp || isWpsAndroid)">-->
                <!--{{item.price}}-->
              <!--</span>-->
                </p>
                <p class="vip-choice-list-average">
                  低至{{item | averagePrice(isApp, isWpsAndroid)}}/天
                </p>
              </li>
            </ul>
          </template>
          <!-- -->
          <div class="vip-choice-ios" v-if="isIosApp">
            <template v-if="signStatus !== 2 && selectType === 0" >
              <h1>畅学卡按月自动续费声明：</h1>
              <p>价格：首月19元，第二个月自动续费58元/月；</p>
              <p>付款：用户确认购买并付款后记入iTunes账户；</p>
              <p>取消续订：用户可自己管理订阅，可随时取消；若需取消自动续费，请在到期前至少24小时设置关闭自动续费，否则订阅会自动续订；关闭后不再扣费；取消步骤为：在iTunes/Apple ID设置管理中，点击取消订阅关闭自动续费；
              </p>
              <p>续费：苹果iTunes账户会在到期前24小时内扣费，扣费成功后订阅周期顺延一个订阅周期。</p>
              <p>试用：如果提供免费试用期，任何未使用的部分将在用户购买该出版物的订阅时被没收（如果适用）</p>
              <div class="vip-choice-ios-bottom">
                <span @click="topage('/ios-rule')">会员服务协议></span>
                <span @click="topage('/ios-sign-rule')">自动续费协议></span>
                <span @click="recoverPay()">恢复购买></span>
                <span @click="topage('/protocol')">隐私服务协议></span>
              </div>
            </template>
            <template v-if="selectType === 1 || signStatus === 2">
              <h1>会员服务协议：</h1>
              <p>1. 会员在有效期内，所有单价698以内的课程皆可免费学习；</p>
              <p>2. 支付完成后，服务立即生效；</p>
              <div class="vip-choice-ios-bottom">
                <span @click="topage('/ios-rule')">会员服务协议></span>
              </div>
            </template>
          </div>
          <div class="vip-choice-remind" @click="$refs.notice.show()" v-if="!selectType && (isWx || isAndroidApp)">
            温馨提示：第二个月自动续费{{cardList[0].price}}/月，可随时取消<img src="./images/important.png" alt="">
          </div>
          <ul class="vip-choice-bonus" v-if="selectType && bonus && isWx">
            <li class="vip-choice-bonus-title flex">
              <p>奖励金</p>
              <p>-￥{{bonus}}</p>
            </li>
            <li class="vip-choice-bonus-main flex">
              <p>{{bonus}}元奖励金</p>
              <div class="checkbox" :class="{'active': active}" @click="handleClick"></div>
            </li>
          </ul>
        </div>
        <div class="vip-choice-bar" @click.stop :class="{IOSButton: isIosApp}" v-if="isIosApp">
          <div @click="buy" class="iosBuy">立即开通</div>
        </div>
        <div v-else class="vip-choice-bar" @click.stop :class="{IOSButton: isIosApp}">
          <div class="vip-choice-bar-info" v-for="(item, index) in cardList" v-if="index === selectType && !isIosApp">
            <div class="vip-choice-bar-countTime" v-if="index && item.discountPrice < item.price && showDiscountTime > 0">
              <img src="../../assets/images/privilege-icon.png" alt="">
              <p>升级倒计时{{showDiscountTime | discountTime}}</p>
            </div>
            <span>￥</span>{{finalPayPrice}}
            <span>{{item | bottomDesc(isApp, isWpsAndroid)}}</span>
          </div>
          <div class="vip-choice-bar-info " v-if="isIosApp"></div>
          <!--<div class="vip-choice-bar-info" v-if="!selectType">-->
          <!--<span>￥</span>{{finalPayPrice}}-->
          <!--<span>{{cardList[0] | bottomDesc}}</span>-->
          <!--</div>-->
          <!--<div class="vip-choice-bar-info" v-if="selectType">-->
          <!--<span>￥</span>{{finalPayPrice}}-->
          <!--<span>{{cardList[1] | bottomDesc}}</span>-->
          <!--</div>-->
          <div @click="buy" class="vip-choice-bar-button">立即开通</div>
        </div>
      </div>
      <Notice ref="notice">
        <div class="notice-main">
          <h1>自动续费说明</h1>
          <ol>
            <li>到期前一天自动为您续费</li>
            <li>扣款前消息通知，完全透明</li>
            <li>尊享超低价优惠</li>
            <li>可随时取消自动续费服务，取消后不再自动续费</li>
          </ol>
          <div class="notice-main-btn" @click="$refs.notice.close()">好的</div>
          <p @click="topage('/vipRules')">查看连续包月服务条款</p>
        </div>
      </Notice>
    </div>
  </div>
</template>

<script>
/*
  wps安卓APP，才博安卓APP 微信内部 正常签约逻辑
  才博IOSAPP 可签约 年卡不可降价
  wps IOS APP 以及其他环境 无法签约
  才博APP 无法使用奖励金
*/
  import Notice from '../Notice'
  import os from '@edu-fe/os'
  import { mapState } from 'vuex'
  import { isxxx } from '@mixins'
  import { setDate } from '../../lib/dateUtils'
  import fixedNumber from '../../filters/fixed-number.js'
  import SignInfo from '../../lib/signInfo'

  export default {
    name: 'VipChoice',
    mixins: [isxxx],
    data () {
      return {
        active: false,
        selectType: 0,
        // cardOptions: [{
        //   title: '连续包月',
        //   discountPrice: 18,
        //   price: 58,
        // },{
        //   title: '连续包月',
        //   discountPrice: 699,
        //   price: 699,
        // }],
        finalPayPrice: 0,  // 最后支付价格
        cardType: 0,
        paying: false,
        price: 0,
        courseId: '',
        showDiscountTime: 0,
        title: ''
      }
    },
    computed: {
      ...mapState(['launchOptions'])
    },
    filters: {
      averagePrice (item, isApp, isWpsAndroid) { // 平均价格
        const { type, firstPrice, discountPrice, price } = item

        if (type === 1) {
          if (os.type !== "weixin" && !isApp && !isWpsAndroid) {
            return (price / 30).toFixed(2)
          }
          return (firstPrice / 30).toFixed(2)
        } else {
          let finalPrice = discountPrice < price ? discountPrice : price
          return (finalPrice / 365).toFixed(2)
        }
      },
      cardPrice (item, isApp, isWpsAndroid) { // 月会员 年会员实际价格
        const { type, firstPrice, discountPrice, price } = item
        if (type === 1) {
          if (os.type !== "weixin" && !isApp && !isWpsAndroid) {
            return price
          }
          return firstPrice
        } else {
          return discountPrice < price ? discountPrice: price
        }
      },
      bottomDesc (item, isApp, isWpsAndroid) { // 底部价格
        const { type, firstPrice, discountPrice, price } = item
        if (type === 1) {
          if (os.type !== "weixin" && !isApp&& !isWpsAndroid) {
            return ''
          }
          return firstPrice > price ? `次月${price}元`: ''
        } else {
          return discountPrice < price ? `原价${price}`: '总价值14850元'
        }
      },
      discountTime (time) {
        return setDate(time)
      }
    },
    watch: {
       cardList: {
         handler (val) {
           let discountTime = val[1].discountEndSeconds
           if (discountTime) {
             setInterval(() => {
               discountTime -= 1000
               this.showDiscountTime = discountTime
             }, 1000)
           }
         },
         deep: true,
         immediate: true
       }
    },
    props: {
      cardList: {
        type: Array,
        required: true
      },
      bonus: {
        type: Number
      },
      signStatus: {
        type: Number
      },
      isBuy: {
        type: Number
      },
      isHuaWei: {
        type: Boolean
      },
      isAndroidApp: {
        type: Boolean
      },
      isIosApp: {
        type: Boolean
      },
      isApp: {
        type: Boolean
      },
      isBuyPush: {
        type: Boolean
      },
      isFilterMonthVip: {
        type: Number
      },
      isAliIos: {
        type: Boolean
      }
    },
    created () {
      this.initChoice()
    },
    methods: {
      recoverPay () {
        return os.sdk.view.goto('restoreGoods', {})
      },
      topage (path) {
        let url = `https://edu-m.wps.cn${path}`
        if (this.isIosApp) {
          return os.sdk.view.goto('onJump', {
            "jumpType":"2",
            "jumpUrl": JSON.stringify({
              "vc":"KSNormalWebViewController",
              "urlString":url,
              "title":"才博"
            })
          })
        }

        this.$router.push({ path })
      },
      initChoice () {
        if (this.isBuyPush) {
          this.chooseType(1, this.cardList[1])
          return
        }
        if (this.isHuaWei || this.isIosApp || this.isFilterMonthVip) {
          this.chooseType(1, this.cardList[1])
          return
        }
        this.chooseType(0, this.cardList[0])
      },
      handleClick () {
        this.active = !this.active
        if (this.active) {
          if (this.finalPayPrice - this.bonus < 0) {
            this.finalPayPrice = 0
          } else {
            this.finalPayPrice = fixedNumber(this.finalPayPrice - this.bonus, 2)
          }
        } else {
          this.finalPayPrice = this.price
        }
      },
      chooseType (index, item) {
        this.selectType = index
        this.cardType = item.type
        this.courseId = item.courseId
        this.title = item.title
        this.active = false
        const { type, firstPrice, discountPrice, price } = item
        if (type === 1) {
          if (os.type !== "weixin" && !this.isApp && !this.isWpsAndroid) {
            this.finalPayPrice = price
          } else {
            this.finalPayPrice = firstPrice
          }
        } else {
          let finalPrice
          if (this.isIosApp) {
            finalPrice = price
          } else {
            finalPrice = discountPrice < price ? discountPrice : price
          }
          this.price = this.finalPayPrice = finalPrice
        }
      },
      async buy () {
        if (this.isAliIos) {
          my.alert({
            content: '请到才博APP购买'
          })
          window.location.href = 'https://itunes.apple.com/app/apple-store/id1439039386?pt=38515&ct=wpsdownload&mt=8'
          return
        }
        let result = await SignInfo.sign({
          courseId: this.courseId,
          cardType: this.cardType,
          finalPayPrice: this.finalPayPrice,
          title: this.title,
          from: this.$route.query.from
        })
        if (!result) {
          await SignInfo.pay({
            courseId: this.courseId,
            finalPayPrice: this.finalPayPrice,
            from: this.launchOptions.from,
            active: this.active,
            emit: () => this.$emit('closeCardChoice'),
            goto: () => {
              this.$router.push({
                name: 'pay',
                query: {
                  courseId: this.courseId,
                  isSend: 1,
                  type: 8,
                  isVipPage: 1
                }
              })
            }
          })
        }
      }
    },
    components: {
      Notice
    }
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";
  .IOSButton {
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      padding-bottom: rem(84);
      background-size: contain;
    }
  }
  .vip-choice {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgba(#000, .4);
    /*.IOSMain {*/
      /*padding: ;*/
      /*@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {*/
        /*bottom: rem(188);*/
      /*}*/
    /*}*/
    &-ios {
      margin-top: rem(10);
      line-height: 1.2;
      h1 {
        font-size: rem(26);
      }
      p {
        font-size: rem(24);
        color: #999;
        margin: rem(5) 0;
      }
      &-bottom {
        padding: rem(15) 0;
        border-top: 1px solid #EBEBEB;
        > span {
          font-size: rem(24);
          /*padding: rem(15) 0;*/
          display: inline-block;
          margin-right: rem(30);
        }
      }
    }
    .notice-main {
      h1 {
        font-size: rem(36);
        padding: rem(40) 0;
        line-height: 1.5;
      }
      ol {
        text-align: center;
        padding-left: rem(80);
        margin-bottom: rem(80);
      }
      li {
        list-style: decimal;
        width: rem(468);
        text-align: left;
        margin: auto;
        padding: rem(10) ;
        color: #666666;
        font-size: rem(30);
      }
      &-btn {
        width: rem(470);
        margin: auto;
        height: rem(70);
        line-height: rem(70);
        color: #fff;
        font-size: rem(32);
        background-image: linear-gradient(to right, #FFB500, #FFB500);
        font-weight: bolder;
        border-radius: rem(10);
      }
      p {
        color: #999999;
        font-size: rem(28);
        padding: rem(30) 0;
      }
    }
    .flex {
      display: flex;
      justify-content: space-between;
    }
    .active {
      background-image: url('../../assets/images/schedule-icon-s.png');
      background-size: contain;
    }
    .chooseActice {
      border: rem(3) solid #FF8C2F;
      background: rgba(#FFD0AA, .3);
    }
    &-bar {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 99999;
      height: rem(100);
      line-height: rem(100);
      &-box {
        width: rem(750);
        display: table;
        margin: 0 auto;
        background: #161B25;
      }
      &-countTime {
        position: absolute;
        top: rem(-30);
        left: rem(50);
        width: rem(270);
        text-align: center;
        >p {
          font-size: rem(24);
          color: #fff;
          line-height: rem(40);
        }
        > img {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }
      }
      &-info {
        width: rem(436);
        height: rem(100);
        // display: inline-block;
        font-size: rem(64);
        float: left;
        color: #FF9036;
        text-align: center;
        > span {
          font-size: rem(42);
          &:last-child {
            font-size: rem(26);
            color: #B8B8B8;
          }
        }
        > del {
          font-size: rem(26);
          color: #B8B8B8;
        }
      }
      &-button {
        width: rem(314);
        height: rem(100);
        line-height: rem(100);
        font-size: rem(42);
        font-weight: bolder;
        text-align: center;
        color: #fff;
        background: linear-gradient(to right, #FFB500, #F46D00);
        display: inline-block;
      }
      .iosBuy {
        width: 100%;
        height: rem(100);
        line-height: rem(100);
        font-size: rem(42);
        font-weight: bolder;
        text-align: center;
        color: #fff;
        background: linear-gradient(to right, #FFB500, #F46D00);
      }
    }

    &-main {
      width: 100%;
      height: rem(637);
      background: white;
      padding: rem(59) rem(30);
      box-sizing: border-box;
      position: fixed;
      bottom: rem(100);
      left: 0;
    }
    .IOSMain {
      padding: rem(30) rem(15);
      @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        bottom: rem(188);
      }
    }
    &-bonus {
      font-size: rem(30);
      color: #666;
      padding: rem(30) 0;
      box-sizing: border-box;
      border-top: 1px solid #ececec;
      border-bottom: 1px solid #ececec;
      &-title {
        margin-bottom: rem(34);
        > p {
          &:first-child {
            font-weight: bold;
          }
          &:last-child {
            color: #FB8F00;
          }
        }
      }
      &-main {
        .checkbox {
          width: rem(39);
          height: rem(39);
          border-radius: 100%;
          border: 1px solid #ececec;
        }
      }
    }
    &-remind {
      color: #999999;
      font-size: rem(26);
      display:flex;
      align-items: center;
      padding: rem(30) 0;
      > img {
        width: rem(30);
      }
    }
    &-list {
      margin-right: rem(-30);
      color: #B8B8B8;
      position: relative;
      .ios-icon {
        width: rem(200);
        height: rem(36);
        background: linear-gradient(to right,#ff852d, #ffa546);
        font-size: rem(20);
        color: #fff;
        text-align: center;
        line-height: rem(36);
        border-top-left-radius: rem(15);
        border-bottom-right-radius:rem(15);
      }
      &-icon {
        position: absolute;
        width: rem(126);
        top: rem(-20);
        left: rem(0);
      }
      &:after {
        content: '';
        display: block;
        clear: both;
      }
      > li {
        min-width: rem(210);
        height: rem(210);
        background: #F5F5F5;
        float: left;
        margin-right: rem(30);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        border-radius: rem(10);
        padding: rem(10);
        box-sizing: border-box;
      }
      &-head {
        font-size: rem(30);
        font-weight: bold;
        color: #333333;
      }
      &-price {
        color: #F46D00;
        font-size: rem(58);
        color: #F46D00;
        font-weight: bold;
        &-dis {
          &:last-child {
            color: #B8B8B8;
            text-decoration: line-through;
          }
        }
        > span {
          font-size: rem(38);
        }
      }
      &-average {
        color: #7A7A7A;
        font-size: rem(20);
      }
    }
  }
</style>
